import { gql } from "@apollo/client";

export const contactFragment = gql`
  fragment contactFragment on ContactObjectType {
    id
    farmId
    name
    email
    phoneNumber
    contactType
    addressLine1
    addressLine2
    city
    country {
      id
      code
      name
    }
    organisationName
    postcode
  }
`;

export const errorFragment = gql`
  fragment errorFragment on ValidationError {
    field
    message
  }
`;
